
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

// import * as api from "../constant/API";

const AcademicSchedule = () => {

    const roleId = localStorage.getItem("RoleId");

    const [searchInput, setSearchInput] = useState("");
    const [scheduleList, setScheduleList] = useState([]);
    const [scdlName, setScdlName] = useState("");
    const [scdlDescription, setScdlDescription] = useState("");
    const [scdlId, setScdlId] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false)

    const formRef = useRef(null);

    // if (roleId === "1") {
    useEffect(() => {
        schedulList()
    }, [])
    // }

    function schedulList() {
        const getScheduleList = api.adminScheduleList;
        fetch(getScheduleList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                setScheduleList(result.data);
            })
            .catch((error) => {
                console.log("Failed to fetch schedule list", error);
            })
    }

    const filteredData = scheduleList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    function newSchedule() {
        setOpenModal(true);
        setIsEdit(false);
        setScdlName("");
        setScdlDescription("");
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editSchedule(rowData)}>
                <i className="feather-edit" />
                Edit
            </Link>
        );
    };

    const slNoRender = (rowData) => {
        return <span>{rowData.schedulesId}</span>;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.schedulesName}</span>;
    };

    const descriptionRender = (rowData) => {
        return <span>{rowData.schedulesDescription}</span>
    }

    function editSchedule(selectedRow) {
        const sdlid = selectedRow.schedulesId;

        const getScdlDetails = api.adminScheduleDetails + '/' + sdlid //"?scheduleId=" + sdlid;
        fetch(getScdlDetails, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((scdlResponse) => scdlResponse.json())
            .then((scdlResult) => {
                // const dta = scdlResult.data[0];
                const dta = scdlResult.data;
                setScdlId(dta.schedulesId);
                setScdlName(dta.schedulesName);
                setScdlDescription(dta.schedulesDescription);
                setIsEdit(true);
                setOpenModal(true)
            })
            .catch((error) => {
                console.log("Failed to fetch the details of the selected schedule.", error)
            })
    }

    function addSchedule(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateSchedule()
            }
            else {
                const formData = new FormData();
                formData.append('scheduleName', scdlName);
                formData.append('scheduleTypeDescription', scdlDescription);

                const scdlAdd = api.adminScheduleCreate;
                fetch(scdlAdd, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
            setOpenModal(false)
        }
    }

    function updateSchedule() {
        const formData = new FormData();
        formData.append('scheduleIdEdit', scdlId);
        formData.append('scheduleNameEdit', scdlName);
        formData.append('scheduleDescriptionEdit', scdlDescription);

        const scdlUpdate = api.adminScheduleUpdate;
        fetch(scdlUpdate, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((updateResponse) => updateResponse.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to update the schedule", error)
            })
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == 1 ? (
                                            <>
                                                <div className="row col-lg-12">
                                                    <div className="col-lg-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={newSchedule}>
                                                            <i className="feather-plus" />&nbsp;
                                                            Add Schedule Type
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="schedulesId"
                                                    body={slNoRender}
                                                    header="Sl No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="schedulesName"
                                                    body={nameRender}
                                                    header="Schedule Name"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="schedulesDescription"
                                                    body={descriptionRender}
                                                    header="Schedule Description"
                                                ></Column>
                                                <Column
                                                    body={editDetails}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*Add/ Edit Schedule Type*/}
            <Modal
                show={openModal}
                size="md"
                centered
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case"><i className="feather-plus" />{isEdit ? "Edit " : "Add "}Schedule Type</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Schedule Name</label>
                                <input
                                    id="batchName"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={scdlName}
                                    required
                                    onChange={(e) => {
                                        setScdlName(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Schedule Description</label>
                                <textarea
                                    id="batchName"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={scdlDescription}
                                    required
                                    onChange={(e) => {
                                        setScdlDescription(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        type="submit"
                        onClick={addSchedule}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                    </Button>
                </ModalFooter>
            </Modal>
            {/* /Add/ Edit Schedule Type*/}
        </>
    );
};

export default AcademicSchedule;